export function firstEntry() {
    let popup = $(".first-entry-popup");

    popup.on('click', function (e) {
        if (e.target.classList.contains('popup-wrap') || e.target.classList.contains('close-popup')) {
            popup.fadeOut("slow");
        }
    });

    $(window).on("load", function () {
        let loadCounter = localStorage.getItem('firstSignIn');

        if (loadCounter === null) {
            popup.css("display", "flex").hide().fadeIn("slow");
            localStorage.setItem("firstSignIn", 'true');
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/first-entry.js